module.exports = __webpack_public_path__ + "img/image-7.dff995ec.webp";